/*
 * Author: Roger
 * File Created: Monday, 24-08-05 06:07 pm
 * Last Modified: Thursday, 25-03-06 11:11 am, by Ben Zhao
 */

import { useEffect, useState } from 'react';
import { animate } from 'framer-motion';
import { type TypographyProps } from '@mui/material';
import { sleep } from '@web/utils';
import { StyledTypingText } from './style';
interface TypingTextProps extends TypographyProps {
  text: string;
  speed: number;
  stay?: number;
  onFinish: () => void;
}
const TypingMText: React.FC<TypingTextProps> = ({
  text,
  speed,
  stay = 1000,
  onFinish,
  ...typoProps
}) => {
  const [displayedText, setDisplayedText] = useState('');
  useEffect(() => {
    const sequence = async () => {
      await animate(0, text.length, {
        duration: text.length * speed / 1000,
        ease: 'linear',
        onUpdate: value => {
          setDisplayedText(` ${text.substring(0, value)}`);
        }
      });
      await sleep(stay);
      await animate(text.length, 0, {
        duration: text.length * speed / 3000,
        ease: 'linear',
        onUpdate: value => {
          setDisplayedText(` ${text.substring(0, value)}`);
        }
      });
      await sleep(stay / 3);
      onFinish();
    };
    sequence();
  }, [text, speed, stay, onFinish]);
  return <StyledTypingText {...typoProps} data-sentry-element="StyledTypingText" data-sentry-component="TypingMText" data-sentry-source-file="TypingText.tsx">{displayedText} </StyledTypingText>;
};
export default TypingMText;